export default __webpack_public_path__ + "static/media/Head_3_Ear_3_C5.89fb0457.svg";